module.exports = __webpack_public_path__ + "img/US_CavArmor_ua.a6ecf507.webp";